import { create } from 'zustand'

export interface NotificationSummary {
  id: string
  type: string
  title: string
  message: string
  read: boolean
  created_at: string
}

interface NotificationState {
  unreadCount: number
  recentNotifications: NotificationSummary[]
  setUnreadCount: (count: number) => void
  incrementUnread: () => void
  markRead: (id: string) => void
  setRecent: (notifications: NotificationSummary[]) => void
  addNotification: (notification: NotificationSummary) => void
}

export const useNotificationStore = create<NotificationState>((set) => ({
  unreadCount: 0,
  recentNotifications: [],

  setUnreadCount: (count) => set({ unreadCount: count }),
  incrementUnread: () => set((s) => ({ unreadCount: s.unreadCount + 1 })),

  markRead: (id) =>
    set((s) => ({
      recentNotifications: s.recentNotifications.map((n) =>
        n.id === id ? { ...n, read: true } : n,
      ),
      unreadCount: Math.max(0, s.unreadCount - 1),
    })),

  setRecent: (notifications) => set({ recentNotifications: notifications }),

  addNotification: (notification) =>
    set((s) => ({
      recentNotifications: [notification, ...s.recentNotifications].slice(0, 20),
    })),
}))
